<template>
  <vs-popup :active.sync="isActive" id="cakeQuestioner">
    <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
      <vs-button size="large" color="transparent" class="payment-label bg-primary2 text-white w-full"
        icon-pack="feather" icon="icon-pie-chart">
        {{ navigationQuestion.questionText }}
      </vs-button>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" vs-justify="space-between" class="p-5">
      <vs-col vs-type="flex" vs-w="5" vs-justify="flex-end">
        <vs-button class="cakeAction" @click="navigate" type="gradient" color="success" icon-pack="feather"
          icon="icon-check"></vs-button>
      </vs-col>
      <vs-col vs-type="flex" vs-w="5" vs-justify="flex-start">
        <vs-button class="cakeAction" @click="moveOn" type="gradient" color="danger" icon-pack="feather" icon="icon-x">
        </vs-button>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
  export default {
    data() {
      return {
        isActive: false,
      }
    },
    methods: {
      navigate() {
        this.isActive = false;
        this.isCakeQuestioned = true;
        this.$store.dispatch("selfservice/hasNeedNavigationByQuestion", true);
      },
      moveOn() {
        this.$emit("moveOn");
        this.isCakeQuestioned = true;
      }
    },
    computed: {
      isCakeQuestioned: {
        get() {
          return this.$store.getters["selfservice/getCakeQuestioned"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setCakeQuestioned", val);
        }
      },
      navigationQuestion() {
        return this.$store.getters["selfservice/getNavigationQuestion"];
      }
    }
  }

</script>

<style>
  #cakeQuestioner .vs-popup .vs-popup--header {
    display: none;
  }

  #cakeQuestioner .vs-popup .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
  }

  #cakeQuestioner .vs-popup {
    border-radius: 2rem !important;
  }

  .cakeAction i {
    font-size: 3rem !important;
  }

  .cakeAction {
    padding: 0;
    width: 8rem !important;
    height: 5.5rem !important;
    font-weight: bold !important;
    border-radius: 3.5rem;
  }

</style>
